import { APIPaginated } from '@/lib/axios'

export function calculateItemsPerPage(
  meta?: APIPaginated<unknown>['meta'],
): number {
  if (!meta) return 0

  const { currentPage, itemsPerPage, totalItems } = meta

  const itemsShown = currentPage * itemsPerPage

  return Math.min(itemsShown, totalItems)
}
